module.exports = __webpack_public_path__ + "img/fao.1852e2db.svg";